import { Injectable } from '@angular/core';
import {
  initialize,
  LDClient,
  LDOptions,
  LDUser
} from 'launchdarkly-js-client-sdk';
import { Subject } from 'rxjs';

import { Feature } from '../models/feature.model';

@Injectable()
export class LaunchDarklyService {
  ldClient: LDClient | undefined;

  public featureValueChanged = new Subject<Feature>();

  initialize(
    apiKey: string,
    isEnabled: boolean,
    user: LDUser,
    options?: LDOptions
  ): Promise<void> {
    return new Promise<void>((resolve, _reject) => {
      if (!isEnabled) {
        resolve();
      } else {
        this.ldClient = initialize(apiKey, user, options);
        this.ldClient.on('ready', () => {
          this.onReady();
          resolve();
        });
      }
    });
  }

  identify(user: LDUser): void {
    if (this.ldClient) {
      this.ldClient.identify(user);
    }
  }

  getFlag(featureName: string): void | boolean {
    if (this.ldClient) {
      return this.ldClient.variation(featureName);
    }
  }

  private onReady(): void {
    if (this.ldClient) {
      this.ldClient.on('change', (settings) => {
        this.onFeatureFlagsChanged(settings);
      });
    }
  }

  private onFeatureFlagsChanged(settings): void {
    for (const feature of Object.keys(settings)) {
      this.featureValueChanged.next(
        new Feature(feature, settings[feature].current)
      );
    }
  }
}
